/* The generic pieces of archetype B's record pages, shared so orders and returns (and any future
   record) don't grow slightly different copies: `KpiStrip`, a row of at-a-glance figures under the
   title — `docs/design/order-page.html` / `return-page.html`'s own `.kpis` (`.dp-kpi*` in
   `detail-page.scss`); and `DetailGroup`, one titled group of name–value rows. */

import React from "react";
import { Descriptions, Typography } from "antd";

export function KpiStrip({ items }) {
  const visible = (items || []).filter(Boolean);
  if (!visible.length) return null;

  return (
    <div className="dp-kpis">
      {visible.map(({ key, label, value }) => (
        <div className="dp-kpi" key={key}>
          <div className="dp-kpi__label">{label}</div>
          <div className="dp-kpi__value">{value}</div>
        </div>
      ))}
    </div>
  );
}

/** A titled group of name–value rows ("Клієнт", "Доставка", "Деталі" on an order or a return) —
    the shape of the rail's `CounterpartySection`: a `dp-card`, its `dp-sec-title`, and
    `<Descriptions column={1}>`. `rows` are `{key, label, value}`, a null one skipped; a group with
    none left is no card at all, so a caller lists only what it means to show. */
export function DetailGroup({ title, rows }) {
  const shown = (rows || []).filter(Boolean);
  if (!shown.length) return null;
  return (
    <div className="dp-card">
      <Typography.Text strong className="dp-sec-title">
        {title}
      </Typography.Text>
      <Descriptions column={1} size="small" colon={false}>
        {shown.map(({ key, label, value }) => (
          <Descriptions.Item key={key} label={label}>
            {value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
}
